module.exports = __webpack_public_path__ + "media/images/cover/house-yard-92c033d81393a0c8de75f6478859df18.jpg";